import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
import { breakpoints } from "../components/mediaQueries";
import "../vendor/slick/slick.js";

$(document).ready(function () {
    //slick slider
    var _slick = false;
    var _is_sliding = false;
    var mobile = window.matchMedia("(max-width: 1005px)");
    $(window)
        .on("resize.gallery", function () {

            if (mobile.matches && !_slick) {
                var carousel = $(".product-single__images-group").slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    slide: ".product-single__images--wrapper",
                    arrows: false,
                    dots: true,
                    rows: 0,
                });
                _slick = true;

                carousel.on("beforeChange", function () {
                    _is_sliding = true;
                });

                carousel.on("afterChange", function () {
                    _is_sliding = false;
                });
            } else if (!mobile.matches && _slick) {
                $(".product-single__images-group").slick("unslick");
                _slick = false;
            }
        })
        .trigger("resize.gallery");

    var pswpElement = document.querySelectorAll(".pswp")[0];

    var gallery;
    var items = [];
    var images = $(".product-single__images--wrapper .zoom__img");

    if (!images.length) {
        return;
    }

    images.each(function () {
        var img = $(this);
        var aspectRatio = parseFloat(img.attr("data-aspectratio"));
        var zoomImg = img.attr("data-zoom-src");
        items.push({
            src: zoomImg,
            w: 2000 * aspectRatio,
            h: 2000,
        });

        img.on("click", function (e) {
            if (_is_sliding) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }

            if (window.PREVENT_ZOOM) return;
            var index = images.index(this);

            var options = {
                index: index,
                zoomEl: true,
                shareEl: false,
                fullscreenEl: false,
                arrowKeys: false,
                counterEl: false,
                showHideOpacity: true,
                /*  getThumbBoundsFn: function(index) {

            // find thumbnail element
            var thumbnail = images[index];

            // get window scroll Y
             var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            // optionally get horizontal scroll

            // get position of element relative to viewport
            var rect = thumbnail.getBoundingClientRect();

            // w = width
            return {x:rect.left, y:rect.top - pageYScroll, w:rect.width};


            // Good guide on how to get element coordinates:
            // http://javascript.info/tutorial/coordinates
        } */
            };

            gallery = new PhotoSwipe(
                pswpElement,
                PhotoSwipeUI_Default,
                items,
                options
            );
            gallery.init();
            gallery.zoomTo(1, {
                x: gallery.viewportSize.x / 2,
                y: gallery.viewportSize.y / 2,
            });
        });
    });
});
